import React, { Component } from "react";
import { withRouter } from "./withRouter";
import { tableFromIPC } from "apache-arrow";
import { DataGrid } from "@mui/x-data-grid";
import { Typography,Box, Stack, Select, 
    FormControl, InputLabel, MenuItem, Card, CardContent, TextField,CircularProgress 
 } from "@mui/material";

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

const PARTY_COLOURS = {
    nat:  "#0056A8" ,
    act: "#FFD700" ,
    nzf:"#000000" ,
};

const possibleAreas = [
  { area_name: "All", area_id: null },
  { area_name: "Auckland Central", area_id: 1 },
  { area_name: "Banks Peninsula", area_id: 2 },
  { area_name: "Botany", area_id: 3 },
  { area_name: "Christchurch Central", area_id: 4 },
  { area_name: "Christchurch East", area_id: 5 },
  { area_name: "Coromandel", area_id: 6 },
  { area_name: "Dunedin", area_id: 7 },
  { area_name: "East Cape", area_id: 8 },
  { area_name: "East Coast Bays", area_id: 9 },
  { area_name: "Epsom", area_id: 10 },
  { area_name: "Glendene", area_id: 11 },
  { area_name: "Hamilton East", area_id: 12 },
  { area_name: "Hamilton West", area_id: 13 },
  { area_name: "Henderson", area_id: 14 },
  { area_name: "Hutt South", area_id: 15 },
  { area_name: "Ilam", area_id: 16 },
  { area_name: "Invercargill", area_id: 17 },
  { area_name: "Kaikōura", area_id: 18 },
  { area_name: "Kaipara ki Mahurangi", area_id: 19 },
  { area_name: "Kapiti", area_id: 20 },
  { area_name: "Kenepuru", area_id: 21 },
  { area_name: "Māngere", area_id: 22 },
  { area_name: "Manurewa", area_id: 23 },
  { area_name: "Maungakiekie", area_id: 24 },
  { area_name: "Mt Albert", area_id: 25 },
  { area_name: "Mt Maunganui", area_id: 26 },
  { area_name: "Mt Roskill", area_id: 27 },
  { area_name: "Napier", area_id: 28 },
  { area_name: "Nelson", area_id: 29 },
  { area_name: "New Plymouth", area_id: 30 },
  { area_name: "North Shore", area_id: 31 },
  { area_name: "Northcote", area_id: 32 },
  { area_name: "Northland", area_id: 33 },
  { area_name: "Ōtāhuhu", area_id: 34 },
  { area_name: "Pakuranga", area_id: 35 },
  { area_name: "Palmerston North", area_id: 36 },
  { area_name: "Papakura", area_id: 37 },
  { area_name: "Port Waikato", area_id: 38 },
  { area_name: "Rangitata", area_id: 39 },
  { area_name: "Rangitīkei", area_id: 40 },
  { area_name: "Remutaka", area_id: 41 },
  { area_name: "Rotorua", area_id: 42 },
  { area_name: "Selwyn", area_id: 43 },
  { area_name: "Southland", area_id: 44 },
  { area_name: "Taieri", area_id: 45 },
  { area_name: "Takanini", area_id: 46 },
  { area_name: "Tāmaki", area_id: 47 },
  { area_name: "Taranaki-King Country", area_id: 48 },
  { area_name: "Taupō", area_id: 49 },
  { area_name: "Tauranga", area_id: 50 },
  { area_name: "Tukituki", area_id: 51 },
  { area_name: "Upper Harbour", area_id: 52 },
  { area_name: "Waikato", area_id: 53 },
  { area_name: "Waimakariri", area_id: 54 },
  { area_name: "Wairarapa", area_id: 55 },
  { area_name: "Waitākere", area_id: 56 },
  { area_name: "Waitaki", area_id: 57 },
  { area_name: "Wellington Bays", area_id: 58 },
  { area_name: "Wellington North", area_id: 59 },
  { area_name: "West Coast-Tasman", area_id: 60 },
  { area_name: "Whanganui", area_id: 61 },
  { area_name: "Whangaparāoa", area_id: 62 },
  { area_name: "Whangārei", area_id: 63 },
  { area_name: "Wigram", area_id: 64 }
];

const POLICY_LABELS = {
  health_importance_p: "Fixing the Health System",
  maori_importance_p: "Managing Māori Issues",
  invest_importance_p: "Investing in Transport and Infrastructure",
  crime_importance_p: "Controlling Crime",
  col_importance_p: "Managing the Cost of Living",
  ed_importance_p: "Improving Education",
};
const POLICY_COL_LABEL = {
  health_importance_p: "health",
  maori_importance_p: "maori",
  invest_importance_p: "invest",
  crime_importance_p: "crime",
  col_importance_p: "col",
  ed_importance_p: "ed",
};



class PolicySummary extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "constituency",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.constituencyMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenDemog:"Gender",
      scatterDemogsRows:null,
      chosenElectorate:null
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
  };
  run();
}


   componentDidUpdate(prevProps, prevState) {
    const chosenElectorateChanged      = prevState.chosenElectorate !== this.state.chosenElectorate;
    const filtersChanged = chosenElectorateChanged


    if (filtersChanged) {
        const run = async () => {
    await this.fetchMetrics("national", this.state.chosenElectorate, true);
    };
    run();
    }
    
  }

 
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;
                
    let turnout_weight
    turnout_weight = "n_raked"

   

    const body = {
      constCode: constCode
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/get_policy_demogs/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
    
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


 handlechosenElectorateChange     = (val) => {this.setState({ chosenElectorate: val })};
   


  render() {

    const {
    //   isPanelOpen,
       metricRows

    } = this.state;


    const DEMO_LABELS = {
  gender: "Gender",
  age: "Age Group",
  ethnicity: "Ethnicity",
  education: "Education Level",
  vote_2023: "2023 Vote",
};
      if (this.state.loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }
    if (!metricRows) {
    return <Typography>No data available</Typography>;
  }

    const sample = metricRows?.[0];

    // Build new rows with top 3 issues
        const enrichedRows = metricRows.map((row, index) => {

      const ed_well_tot= row["nat_p_ed_well"]+row["act_p_ed_well"]+row["nzf_p_ed_well"]
      const norm_nat_p_ed_well = (row["nat_p_ed_well"]/ed_well_tot)*100
      const norm_act_p_ed_well= (row["act_p_ed_well"]/ed_well_tot)*100
      const norm_nzf_p_ed_well = (row["nzf_p_ed_well"]/ed_well_tot)*100
      
      const ed_poor_tot= row["nat_p_ed_poor"]+row["act_p_ed_poor"]+row["nzf_p_ed_poor"]
      const norm_nat_p_ed_poor = (row["nat_p_ed_poor"]/ed_poor_tot)*100
      const norm_act_p_ed_poor= (row["act_p_ed_poor"]/ed_poor_tot)*100
      const norm_nzf_p_ed_poor = (row["nzf_p_ed_poor"]/ed_poor_tot)*100

      const health_well_tot= row["nat_p_health_well"]+row["act_p_health_well"]+row["nzf_p_health_well"]
      const norm_nat_p_health_well = (row["nat_p_health_well"]/health_well_tot)*100
      const norm_act_p_health_well= (row["act_p_health_well"]/health_well_tot)*100
      const norm_nzf_p_health_well = (row["nzf_p_health_well"]/health_well_tot)*100
      
      const health_poor_tot= row["nat_p_health_poor"]+row["act_p_health_poor"]+row["nzf_p_health_poor"]
      const norm_nat_p_health_poor = (row["nat_p_health_poor"]/health_poor_tot)*100
      const norm_act_p_health_poor= (row["act_p_health_poor"]/health_poor_tot)*100
      const norm_nzf_p_health_poor = (row["nzf_p_health_poor"]/health_poor_tot)*100


      const col_well_tot= row["nat_p_col_well"]+row["act_p_col_well"]+row["nzf_p_col_well"]
      const norm_nat_p_col_well = (row["nat_p_col_well"]/col_well_tot)*100
      const norm_act_p_col_well= (row["act_p_col_well"]/col_well_tot)*100
      const norm_nzf_p_col_well = (row["nzf_p_col_well"]/col_well_tot)*100
      
      const col_poor_tot= row["nat_p_col_poor"]+row["act_p_col_poor"]+row["nzf_p_col_poor"]
      const norm_nat_p_col_poor = (row["nat_p_col_poor"]/col_poor_tot)*100
      const norm_act_p_col_poor= (row["act_p_col_poor"]/col_poor_tot)*100
      const norm_nzf_p_col_poor = (row["nzf_p_col_poor"]/col_poor_tot)*100


      const crime_well_tot= row["nat_p_crime_well"]+row["act_p_crime_well"]+row["nzf_p_crime_well"]
      const norm_nat_p_crime_well = (row["nat_p_crime_well"]/crime_well_tot)*100
      const norm_act_p_crime_well= (row["act_p_crime_well"]/crime_well_tot)*100
      const norm_nzf_p_crime_well = (row["nzf_p_crime_well"]/crime_well_tot)*100
      
      const crime_poor_tot= row["nat_p_crime_poor"]+row["act_p_crime_poor"]+row["nzf_p_crime_poor"]
      const norm_nat_p_crime_poor = (row["nat_p_crime_poor"]/crime_poor_tot)*100
      const norm_act_p_crime_poor= (row["act_p_crime_poor"]/crime_poor_tot)*100
      const norm_nzf_p_crime_poor = (row["nzf_p_crime_poor"]/ed_poor_tot)*100

      const maori_well_tot= row["nat_p_maori_well"]+row["act_p_maori_well"]+row["nzf_p_maori_well"]
      const norm_nat_p_maori_well = (row["nat_p_maori_well"]/maori_well_tot)*100
      const norm_act_p_maori_well= (row["act_p_maori_well"]/maori_well_tot)*100
      const norm_nzf_p_maori_well = (row["nzf_p_maori_well"]/maori_well_tot)*100
      
      const maori_poor_tot= row["nat_p_maori_poor"]+row["act_p_maori_poor"]+row["nzf_p_maori_poor"]
      const norm_nat_p_maori_poor = (row["nat_p_maori_poor"]/maori_poor_tot)*100
      const norm_act_p_maori_poor= (row["act_p_maori_poor"]/maori_poor_tot)*100
      const norm_nzf_p_maori_poor = (row["nzf_p_maori_poor"]/maori_poor_tot)*100


      
      const invest_well_tot= row["nat_p_invest_well"]+row["act_p_invest_well"]+row["nzf_p_invest_well"]
      const norm_nat_p_invest_well = (row["nat_p_invest_well"]/invest_well_tot)*100
      const norm_act_p_invest_well= (row["act_p_invest_well"]/invest_well_tot)*100
      const norm_nzf_p_invest_well = (row["nzf_p_invest_well"]/invest_well_tot)*100
      
      const invest_poor_tot= row["nat_p_invest_poor"]+row["act_p_invest_poor"]+row["nzf_p_invest_poor"]
      const norm_nat_p_invest_poor = (row["nat_p_invest_poor"]/invest_poor_tot)*100
      const norm_act_p_invest_poor= (row["act_p_invest_poor"]/invest_poor_tot)*100
      const norm_nzf_p_invest_poor = (row["nzf_p_invest_poor"]/invest_poor_tot)*100
      return {
        id: index,
        ...row,
      nat_p_ed_well:norm_nat_p_ed_well,
      act_p_ed_well:norm_act_p_ed_well,
      nzf_p_ed_well:norm_nzf_p_ed_well,

      nat_p_ed_poor:norm_nat_p_ed_poor,
      act_p_ed_poor:norm_act_p_ed_poor,
      nzf_p_ed_poor:norm_nzf_p_ed_poor,

      nat_p_health_well:norm_nat_p_health_well,
      act_p_health_well:norm_act_p_health_well,
      nzf_p_health_well:norm_nzf_p_health_well,

      nat_p_health_poor:norm_nat_p_health_poor,
      act_p_health_poor:norm_act_p_health_poor,
      nzf_p_health_poor:norm_nzf_p_health_poor,
      
      nat_p_col_well:norm_nat_p_col_well,
      act_p_col_well:norm_act_p_col_well,
      nzf_p_col_well:norm_nzf_p_col_well,

      nat_p_col_poor:norm_nat_p_col_poor,
      act_p_col_poor:norm_act_p_col_poor,
      nzf_p_col_poor:norm_nzf_p_col_poor,


      nat_p_crime_well:norm_nat_p_crime_well,
      act_p_crime_well:norm_act_p_crime_well,
      nzf_p_crime_well:norm_nzf_p_crime_well,

      nat_p_crime_poor:norm_nat_p_crime_poor,
      act_p_crime_poor:norm_act_p_crime_poor,
      nzf_p_crime_poor:norm_nzf_p_crime_poor,

      nat_p_maori_well:norm_nat_p_maori_well,
      act_p_maori_well:norm_act_p_maori_well,
      nzf_p_maori_well:norm_nzf_p_maori_well,

      nat_p_maori_poor:norm_nat_p_maori_poor,
      act_p_maori_poor:norm_act_p_maori_poor,
      nzf_p_maori_poor:norm_nzf_p_maori_poor,

      nat_p_invest_well:norm_nat_p_invest_well,
      act_p_invest_well:norm_act_p_invest_well,
      nzf_p_invest_well:norm_nzf_p_invest_well,

      nat_p_invest_poor:norm_nat_p_invest_poor,
      act_p_invest_poor:norm_act_p_invest_poor,
      nzf_p_invest_poor:norm_nzf_p_invest_poor,
      };
    });
    

    // ---- Gradient blending helpers ----
const blendToColour = (value, { min, max }, rgb) => {
  if (value == null || Number.isNaN(value) || max === min) return "#fff";
  const ratio = Math.min(Math.max((value - min) / (max - min), 0), 1);
  const [r, g, b] = rgb;
  const blended = [
    Math.round(255 - (255 - r) * ratio),
    Math.round(255 - (255 - g) * ratio),
    Math.round(255 - (255 - b) * ratio),
  ];
  return `rgb(${blended.join(",")})`;
};

// ---- Red–white–green for net columns ----
const blendPerformanceColour = (value, { min, max }) => {
  if (value == null || Number.isNaN(value) || max === min) return "#fff";
  const midpoint = 0;
  if (value < midpoint) {
    // red to white
    const ratio = Math.abs((value - midpoint) / (min - midpoint));
    const r = 255;
    const g = Math.round(255 - (255 - 150) * ratio);
    const b = Math.round(255 - (255 - 150) * ratio);
    return `rgb(${r},${g},${b})`;
  } else {
    // white to green
    const ratio = (value - midpoint) / (max - midpoint);
    const r = Math.round(255 - (255 - 0) * ratio);
    const g = Math.round(255 - (255 - 128) * ratio);
    const b = Math.round(255 - (255 - 0) * ratio);
    return `rgb(${r},${g},${b})`;
  }
};

// Choose text colour (white on dark backgrounds, black otherwise)
const getTextColour = (value, { min, max }, rgb) => {
  if (value == null || Number.isNaN(value) || max === min) return "#000";
  const ratio = (value - min) / (max - min);
  const [r, g, b] = rgb;
  const blended = [
    Math.round(255 - (255 - r) * ratio),
    Math.round(255 - (255 - g) * ratio),
    Math.round(255 - (255 - b) * ratio),
  ];
  const brightness = (blended[0] * 299 + blended[1] * 587 + blended[2] * 114) / 1000;
  return brightness < 180 ? "#fff" : "#000";
};

const makePercentColumn = (field, headerName, opts = {}) => {
  let rgb = [200, 200, 200];
  let colourType = "neutral";

  if (field.includes("_importance")) {
    rgb = [0, 102, 204];
    colourType = "importance";
  } else if (field.startsWith("gov_net")) {
    colourType = "net";
  } else if (field.startsWith("nat_p_")) {
    rgb = [0, 86, 168];
    colourType = "party";
  } else if (field.startsWith("act_p_")) {
    rgb = [255, 215, 0];
    colourType = "party";
  } else if (field.startsWith("nzf_p_")) {
    rgb = [0, 0, 0];
    colourType = "party";
  }

  return {
    field,
    headerName,
    flex: 1,
    minWidth: opts.minWidth ?? 130,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      const mm = opts.minMax ?? { min: -50, max: 50 };

      let bg;
      if (colourType === "net") bg = blendPerformanceColour(value, mm);
      else bg = blendToColour(value, mm, rgb);

      const textColour = getTextColour(value, mm, rgb);

      return (
        <div
          style={{
            backgroundColor: bg,
            color: textColour,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            borderLeft: opts.leftBorder ? "4px solid #ccc" : "none",
          }}
        >
          {value == null || Number.isNaN(value) ? "" : `${Number(value).toFixed(1)}%`}
        </div>
      );
    },
  };
};
const makeRAGColumn = (field, headerName, opts = {}) => {
  let rgb = [200, 200, 200];
  let colourType = "neutral";

  if (field.includes("_importance")) {
    rgb = [0, 102, 204];
    colourType = "importance";
  } else if (field.startsWith("gov_net")) {
    colourType = "net";
  } else if (field.startsWith("nat_p_")) {
    rgb = [0, 86, 168];
    colourType = "party";
  } else if (field.startsWith("act_p_")) {
    rgb = [255, 215, 0];
    colourType = "party";
  } else if (field.startsWith("nzf_p_")) {
    rgb = [0, 0, 0];
    colourType = "party";
  }

  return {
    field,
    headerName,
    flex: 1,
    minWidth: opts.minWidth ?? 130,
    sortable: true,
    renderCell: (params) => {
      const value = params.value;
      const mm = opts.minMax ?? { min: -50, max: 50 };

      let bg;
      if (colourType === "net") bg = blendPerformanceColour(value, mm);
      else bg = blendToColour(value, mm, rgb);

      const textColour = getTextColour(value, mm, rgb);

      return (
        <div
          style={{
            backgroundColor: bg,
            color: textColour,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            borderLeft: opts.leftBorder ? "4px solid #ccc" : "none",
          }}
        >
          {value == null || Number.isNaN(value) ? "" : `${Number(value).toFixed(0)/100}`}
        </div>
      );
    },
  };
};

const CATEGORY_LABELS = {
  DNV: "Did not vote",
  NAT: "National",
  ACT: "ACT",
  LAB: "Labour",
  GREEN: "Green",
  NZF: "NZ First",
  TPM: "Te Pāti Māori",
  European: "European",
  "Non-European": "Non-European",
  High: "High",
  Mid: "Mid",
  Low: "Low",
  F: "Female",
  M: "Male",
  Young: "Young",
  Middle: "Middle-aged",
  Old: "Older",
};


   // Generate columns dynamically
 // === Basic identifiers ===
const columns = [
  { field: "demographic", headerName: "Demographic", flex: 1, minWidth: 150,
  renderCell: (params) => DEMO_LABELS[params.value] ?? params.value, },
  { field: "demographic_level", headerName: "Category", flex: 1, minWidth: 150,
  renderCell: (params) => CATEGORY_LABELS[params.value] ?? params.value, },

  // === Cost of Living ===
  makeRAGColumn("col_importance_p", "Cost of Living Importance", { leftBorder: true }),
  makePercentColumn("gov_net_col", "Gov. Doing Well – Cost of Living"),
  makePercentColumn("nat_p_col_well", "NAT Well – Cost of Living"),
  makePercentColumn("nat_p_col_poor", "NAT Poor – Cost of Living"),
  makePercentColumn("act_p_col_well", "ACT Well – Cost of Living"),
  makePercentColumn("act_p_col_poor", "ACT Poor – Cost of Living"),
  makePercentColumn("nzf_p_col_well", "NZF Well – Cost of Living"),
  makePercentColumn("nzf_p_col_poor", "NZF Poor – Cost of Living"),

  // === Health ===
  makeRAGColumn("health_importance_p", "Health Importance", { leftBorder: true }),
  makePercentColumn("gov_net_health", "Gov. Doing Well – Health"),
  makePercentColumn("nat_p_health_well", "NAT Well – Health"),
  makePercentColumn("nat_p_health_poor", "NAT Poor – Health"),
  makePercentColumn("act_p_health_well", "ACT Well – Health"),
  makePercentColumn("act_p_health_poor", "ACT Poor – Health"),
  makePercentColumn("nzf_p_health_well", "NZF Well – Health"),
  makePercentColumn("nzf_p_health_poor", "NZF Poor – Health"),

  // === Education ===
  makeRAGColumn("ed_importance_p", "Education Importance", { leftBorder: true }),
  makePercentColumn("gov_net_ed", "Gov. Doing Well – Education"),
  makePercentColumn("nat_p_ed_well", "NAT Well – Education"),
  makePercentColumn("nat_p_ed_poor", "NAT Poor – Education"),
  makePercentColumn("act_p_ed_well", "ACT Well – Education"),
  makePercentColumn("act_p_ed_poor", "ACT Poor – Education"),
  makePercentColumn("nzf_p_ed_well", "NZF Well – Education"),
  makePercentColumn("nzf_p_ed_poor", "NZF Poor – Education"),

  // === Crime ===
  makeRAGColumn("crime_importance_p", "Crime Importance", { leftBorder: true }),
  makePercentColumn("gov_net_crime", "Gov. Doing Well – Crime"),
  makePercentColumn("nat_p_crime_well", "NAT Well – Crime"),
  makePercentColumn("nat_p_crime_poor", "NAT Poor – Crime"),
  makePercentColumn("act_p_crime_well", "ACT Well – Crime"),
  makePercentColumn("act_p_crime_poor", "ACT Poor – Crime"),
  makePercentColumn("nzf_p_crime_well", "NZF Well – Crime"),
  makePercentColumn("nzf_p_crime_poor", "NZF Poor – Crime"),

  // === Investment ===
  makeRAGColumn("invest_importance_p", "Investment Importance", { leftBorder: true }),
  makePercentColumn("gov_net_invest", "Gov. Doing Well – Investment"),
  makePercentColumn("nat_p_invest_well", "NAT Well – Investment"),
  makePercentColumn("nat_p_invest_poor", "NAT Poor – Investment"),
  makePercentColumn("act_p_invest_well", "ACT Well – Investment"),
  makePercentColumn("act_p_invest_poor", "ACT Poor – Investment"),
  makePercentColumn("nzf_p_invest_well", "NZF Well – Investment"),
  makePercentColumn("nzf_p_invest_poor", "NZF Poor – Investment"),

  // === Māori Issues ===
  makeRAGColumn("maori_importance_p", "Māori Issues Importance", { leftBorder: true }),
  makePercentColumn("gov_net_maori", "Gov. Doing Well – Māori Issues"),
  makePercentColumn("nat_p_maori_well", "NAT Well – Māori Issues"),
  makePercentColumn("nat_p_maori_poor", "NAT Poor – Māori Issues"),
  makePercentColumn("act_p_maori_well", "ACT Well – Māori Issues"),
  makePercentColumn("act_p_maori_poor", "ACT Poor – Māori Issues"),
  makePercentColumn("nzf_p_maori_well", "NZF Well – Māori Issues"),
  makePercentColumn("nzf_p_maori_poor", "NZF Poor – Māori Issues"),

];




  // Add a unique id for each row (DataGrid requires it)
  const formattedRows = enrichedRows.map((row, i) => ({ id: i, ...row }));

    
  
  return(
     <Box sx={{ height: "92vh", display: "flex", flexDirection: "column", width:'100%' }}>
        {/* HEADER (auto height, no flexGrow) */}
        <Box
          sx={(theme) => ({
            height:"20%",
            px: 3, py: 3,
            display: "flex", alignItems: "center",
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : theme.palette.background.default,
            borderBottom: `1px solid ${theme.palette.divider}`,
            // no flexGrow, no % height here
          })}
        >
          {/* left: icon + text */}
          <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
    
            <Box>
              <Typography variant="h5" fontWeight={700}>Policy Summary</Typography>
              <Typography variant="body1" color="text.secondary">
                Select an electorate to view their policy-party scores
              </Typography>
            </Box>
                        <TextField
                        select
                        label="Electorate"
                        size="small"
                        value={this.state.chosenElectorate}
                        onChange={(e) => this.handlechosenElectorateChange?.(e.target.value)}
                        sx={{ minWidth: 180 }}
                        >
                        {possibleAreas.map((area) => (
                            <MenuItem key={area.area_name ?? "all"} value={area.area_id}>
                            {area.area_name}
                            </MenuItem>
                        ))}
                        </TextField>

          </Stack>
          
        </Box>

                <Box
                    sx={{
                                            width: "100%",
                                            height:"100%"
                                        }}
                                        >
                                   <DataGrid
                                    rows={formattedRows}
                                    columns={columns}
                                    density="compact"
                                    disableRowSelectionOnClick
                                     hideFooter   
                                    initialState={{
                                    pagination: { paginationModel: { pageSize: 30 } },
                                    }}
                                    pageSizeOptions={[10, 20, 50]}
                                     sx={{
                        "& .MuiDataGrid-virtualScroller": {
                            overflowY: "auto",
                        },

                        // === Base cell alignment ===
                        "& .MuiDataGrid-cell": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                            p: 0,
                            lineHeight: 1.2,
                            borderRight: "1px solid #ddd", // standard dividers
                        },

                        "& .MuiDataGrid-cell:last-of-type": {
                            borderRight: "none",
                        },

                        // === Header styles ===
                        "& .MuiDataGrid-columnHeaders": {
                            fontWeight: "bold",
                            backgroundColor: "#fafafa",
                            borderBottom: "2px solid #bbb",
                        },

                        "& .MuiDataGrid-columnHeader": {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRight: "1px solid #ddd",
                        },

                        "& .MuiDataGrid-columnHeader:last-of-type": {
                            borderRight: "none",
                        },

                        "& .MuiDataGrid-columnHeaderTitleContainer": {
                            flex: 1,
                            justifyContent: "center",
                        },

                        "& .MuiDataGrid-columnHeaderTitle": {
                              whiteSpace: "normal",      // ✅ allow wrapping
                                    lineHeight: 1.2,           // tighter vertical spacing
                                    overflow: "visible",       // prevent text clipping
                                    textAlign: "center",       // keep your centred alignment
                                    width: "100%",
                                    display: "block",          // ensures wrapping applies properly
                                    wordBreak: "break-word",   // handle very long words
                        },

                        // === ✅ Thick group dividers using [data-field] ===
                        '& .MuiDataGrid-cell[data-field="tpm_pred_n"]': {
                            borderRight: "2px solid #555",
                        },
                        '& .MuiDataGrid-cell[data-field="gov_performace"]': {
                            borderRight: "2px solid #555",
                        },
                        // '& .MuiDataGrid-cell[data-field="nat_pred_n"]': {
                        //     borderLeft: "2px solid #555",
                        // },
                        '& .MuiDataGrid-cell[data-field="turnout_1_p"]': {
                            borderRight: "2px solid #555",
                        },
                        '& .MuiDataGrid-cell[data-field="top_issue_3"]': {
                            borderRight: "2px solid #555",
                        },


                        // === National row style ===
                        "& .national-row": {
                            fontWeight: "bold",
                            backgroundColor: "rgba(0,0,0,0.05)",
                        },

                        // === Left-aligned exceptions ===
                        "& .left-align": {
                            justifyContent: "flex-start",
                            textAlign: "left",
                            pl: 1,
                        },
                        }}
                                />
    
      </Box>
      </Box>
  

  )
}


  }

export default withRouter(PolicySummary);